import React from "react";
import parse from "html-react-parser";
import DOMPurify from "dompurify";

interface Props {
  html: string;
}

export default function HtmlContent({ html }: Props) {
  function sanitizeAndParse(content: string) {
    const clean = DOMPurify.sanitize(content);
    return parse(clean);
  }

  return <div>{sanitizeAndParse(html)}</div>;
}
